module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "background": "#fcfcfd"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticStyle: {
      "padding-top": "20px"
    }
  }, [_c('span', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        return _vm.gotoHome()
      }
    }
  }, [_vm._v("HOME")]), _vm._v(" - ABOUT US - COMPANY")]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "padding": "30px 0px",
      "padding-top": "15px"
    }
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('left')], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-9",
    staticStyle: {
      "color": "#333",
      "font-size": "15px",
      "line-height": "25px"
    }
  }, [_vm._m(0), _vm._v(" "), (_vm.$i18n.locale == 'en') ? _c('p', [_vm._v("\n                ADA Chemical is a professional manufacture of chemical raw materials. Our sales and service center is in Shanghai, and our production base is located in Zibo City, Shandong Province, which is well-known as the supper-large chemical city in China.\n            ")]) : _vm._e(), _vm._v(" "), (_vm.$i18n.locale == 'en') ? _c('p', [_vm._v("\n            Established in 1995, we have more than 20 years 'experience in chemical industry. Now the company has an asset of over 30,000,000RMB, covers 10,000 square meters, and we have more than 120 employees now.\n\n            ")]) : _vm._e(), _vm._v(" "), (_vm.$i18n.locale == 'en') ? _c('p', [_vm._v("\n            After 20 years’ technology accumulation and market development, we are now dedicated in the following products:\n            ")]) : _vm._e(), _vm._v(" "), (_vm.$i18n.locale == 'en') ? _c('ul', [_c('li', [_vm._v("\n                Aluminum hydroxide:  We are producing different particle size of ATH，our superfine model is up to 1um, the main applications are for flame retardant, solid surface, glass, alum, etc.")]), _c('li', [_vm._v("\n                PVC raw materials: We can supply full series of PVC materials, such as PVC Resin, PVC Stabilizer, CPE, blowing agent, lubricant, plasticizer, pigments, etc. Not only supply all these materials, we can also provide technical support for our customers during their production.")]), _c('li', [_vm._v("\n                Boron Nitride: Our Boron Nitride products are price competitive and high quality, we can provide both powders and coating. It is mainly used in precision molding, high temperature resistant, structural material, etc.")]), _c('li', [_vm._v("\n                Raw materials: Such as Purified Terephthalic acid (PTA), HPMC&CMC, HDPE&LDPE, Dicyandiamide, Melamine, etc.")]), _c('li', [_vm._v("\n                Food additives: Sodium bicarbonate, sodium acid pyrophosphate, ammonium bicarbonate, etc.")])]) : _vm._e(), _vm._v(" "), (_vm.$i18n.locale == 'en') ? _c('p', [_vm._v("\n                We believe that our factory direct prices will low down your cost and help you to grow your business. All staff of ADA Chemicals warmly welcome customers and friends all over the world.\n\n            ")]) : _vm._e(), _vm._v(" "), (_vm.$i18n.locale == 'zh') ? _c('p', [_vm._v("\n                爱代化工是一家化工原材料专业生产厂家，我们的生产基地座落在山东省淄博市，并在上海设有销售和服务中心。爱代化工成立于1995年，有着20多年的化工行业经验。公司生产基地占地面积约10000平方米，现有员工120多名。\n\n            ")]) : _vm._e(), _vm._v(" "), (_vm.$i18n.locale == 'zh') ? _c('p', [_vm._v("\n                公司主要产品有氢氧化铝，氮化硼，PVC添加剂等，广泛应用于PVC、橡胶、建材、电子、水处理等多个领域。公司产品品质优异，部分产品可直接替代进口原料，并长期出口东南亚、中东、及欧美的多个国家和地区。\n\n            ")]) : _vm._e(), _vm._v(" "), (_vm.$i18n.locale == 'zh') ? _c('p', [_vm._v("\n                经过20多年的积累，公司不但拥有独立的生产设备，也配备了精密的测试仪器。公司培训了一批高素质的员工队伍，确保本公司的产品质量更加稳固可靠。我们的技术专家和客户服务人员致力于提供最优质的服务，帮助您找到合适的原材料，并为您产品测试、应用、落地等提供全套的技术支持和售后保障。\n\n            ")]) : _vm._e(), _vm._v(" "), (_vm.$i18n.locale == 'zh') ? _c('p', [_vm._v("\n                我们致力于用更优良的产品质量和服务来满足客户的要求。 “科技为本、诚信经营”是公司一贯恪守的宗旨。稳步发展、与时俱进。公司期待与国内外新老客户真诚合作，共赢未来！\n\n            ")]) : _vm._e()])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-bottom": "30px"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100%",
      "box-shadow": "0px 0px 10px #aaa"
    },
    attrs: {
      "src": "/static/images/about-us-company.jpg"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6a820fcf"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/aboutus.vue
// module id = 1396
// module chunks = 1